import ButtonIcon from "#common/buttons/ButtonIcon"
import { MasterDialog } from "#common/Dialog/Dialog"
import React, { Fragment } from "react"
import VacationDetails from "./VacationDetails"
import InfoIcon from "@mui/icons-material/Info"
export default function VacationDetailsDialog({ id }) {
	const [open, setOpen] = React.useState(false)

	return (
		<Fragment>
			<ButtonIcon
				title="Información"
				icon={<InfoIcon />}
				onClick={() => {
					setOpen(true)
				}}
			/>
			<MasterDialog
				{...{
					open,
					setOpen,
					maxWidth: "sm",
				}}
			>
				<VacationDetails id={id} />
			</MasterDialog>
		</Fragment>
	)
}
